document.addEventListener('submit', async function(event) {
  var form = event.target.closest('[data-quick-add-form]');
  if (!form) return;
  event.preventDefault();
  
  var button = form.querySelector('[data-quick-add-button]');
  if (!button || button.disabled || button.classList.contains('is-loading')) return;
  
  var label = button.querySelector('span');
  button.classList.remove('is-added', 'is-error');
  button.classList.add('is-loading');
  
  try {
    var response = await fetch(form.action, {
      method: 'POST',
      body: new FormData(form),
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
    });
    
    if (!response.ok) throw new Error('Cart request failed');
    
    var cartResponse = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    var cart = await cartResponse.json();
    
    // Explicitly update header count first just in case
    document.querySelectorAll('.cart b').forEach(function(count) { 
      count.textContent = cart.item_count; 
    });
    
    // Attempt to open the drawer
    if (window.CartDrawerInstance) {
      await window.CartDrawerInstance.refresh();
      window.CartDrawerInstance.open();
    } else {
      // If drawer fails to initialize, fallback to cart page
      window.location.href = '/cart';
      return;
    }
    
    button.classList.add('is-added');
    if (label) label.textContent = button.dataset.addedLabel;
    
    window.setTimeout(function() {
      button.classList.remove('is-added');
      if (label) label.textContent = button.dataset.addLabel;
    }, 1600);
    
  } catch (error) {
    console.error('Quick add error:', error);
    button.classList.add('is-error');
    window.setTimeout(function() { button.classList.remove('is-error'); }, 1600);
  } finally {
    button.classList.remove('is-loading');
  }
});
